module.exports = __webpack_public_path__ + "img/03-home.ea4264b7.png";